import { objectToString } from "../utils/helpers";
import { TSyncSource } from "./base";

export interface ISyncDelayObject {
    min: number;
    max: number;
    median: number;
    avg: number;
    newLogCount: number;
}

export interface ISyncSummaryObject {
    type: string;
    localFeedVersion: IIdDictionary<string>;
    source: TSyncSource | "unknown";
    downloaded?: number;
    uploaded?: number;
    delay?: ISyncDelayObject;
}

export class SyncLogger {
    private uploadedLogs: string[] = [];
    private downloadedLogs: string[] = [];
    private localFeedVersion: IIdDictionary<string> = {};
    private source: TSyncSource | undefined;
    private delay?: ISyncDelayObject;

    toServer<T>(obj: T) {
        this.uploadedLogs.push(`=> ${ objectToString(obj) }`);
    }

    fromServer<T>(obj: T) {
        this.downloadedLogs.push(`<= ${ objectToString(obj) }`);
    }

    getLogs() {
        let delimiter = "=========================================";
        if (!this.uploadedLogs.length && !this.downloadedLogs.length){
            return delimiter;
        }
        let logs = ["", delimiter].concat(this.uploadedLogs, this.downloadedLogs, [delimiter]);
        return logs.join("\n");
    }

    resetState() {
        this.uploadedLogs = [];
        this.downloadedLogs = [];
        this.localFeedVersion = {};
        this.source = undefined;
        this.delay = undefined;
    }

    setFeedVersion(key: string, value: string) {
        this.localFeedVersion[key] = value;
    }

    getSyncSummary(type: string) {
        const syncObject: ISyncSummaryObject = {
            type,
            localFeedVersion: this.localFeedVersion,
            source: this.source ?? "unknown"
        };
        if (this.downloadedLogs?.length) {
            syncObject.downloaded = this.downloadedLogs.length;
        }
        if (this.uploadedLogs?.length) {
            syncObject.uploaded = this.uploadedLogs.length;
        }
        if (this.delay) {
            syncObject.delay = this.delay;
        }
        return JSON.stringify(syncObject);
    }

    setSource(source: TSyncSource) {
        this.source = source;
    }

    setDelay(delayObject: ISyncDelayObject) {
        this.delay = delayObject;
    }
}